import { create } from 'zustand';
const defaultToolpads = {
    library: { id: 'library', isOpen: true, position: 'left' },
    clipFolders: { id: 'clipFolders', isOpen: false, position: 'left' },
    sceneObjectList: { id: 'sceneObjectList', isOpen: true, position: 'left' },
    sceneEffectList: { id: 'sceneEffectList', isOpen: true, position: 'left' },
    stylePad: { id: 'stylePad', isOpen: true, position: 'right' },
    objectProperties: { id: 'objectProperties', isOpen: true, position: 'right' },
    sceneList: { id: 'sceneList', isOpen: false, position: 'left' },
    movieProperties: { id: 'movieProperties', isOpen: false, position: 'left' },
    alignPad: { id: 'alignPad', isOpen: false, position: 'right' },
    arrowPad: { id: 'arrowPad', isOpen: false, position: 'right' },
    spritePad: { id: 'spritePad', isOpen: false, position: 'right' },
    spriteListPad: { id: 'spriteListPad', isOpen: false, position: 'right' },
    spriteGroupPad: { id: 'spriteGroupPad', isOpen: false, position: 'right' },
    zoomPad: { id: 'zoomPad', isOpen: false, position: 'right' },
};
export const useUIStore = create((set) => ({
    // Initial state
    toolpads: defaultToolpads,
    keepAspectRatio: true,
    setKeepAspectRatio: (enabled) => set({ keepAspectRatio: enabled }),
    toggleKeepAspectRatio: () => set((state) => ({ keepAspectRatio: !state.keepAspectRatio })),
    stageResizeEnabled: true,
    stageRotateEnabled: false,
    setStageResizeEnabled: (enabled) => set({
        stageResizeEnabled: enabled,
        ...(enabled ? { stageRotateEnabled: false } : {}),
    }),
    setStageRotateEnabled: (enabled) => set({
        stageRotateEnabled: enabled,
        ...(enabled ? { stageResizeEnabled: false } : {}),
    }),
    toggleStageResizeEnabled: () => set((state) => {
        const next = !state.stageResizeEnabled;
        return {
            stageResizeEnabled: next,
            ...(next ? { stageRotateEnabled: false } : {}),
        };
    }),
    toggleStageRotateEnabled: () => set((state) => {
        const next = !state.stageRotateEnabled;
        return {
            stageRotateEnabled: next,
            ...(next ? { stageResizeEnabled: false } : {}),
        };
    }),
    modal: { isOpen: false, type: null, data: null },
    leftSidebarOpen: true,
    rightSidebarOpen: true,
    bottomPanelOpen: true,
    welcomeOpen: true,
    setWelcomeOpen: (open) => set({ welcomeOpen: open }),
    // Toolpad actions
    toggleToolpad: (id) => set((state) => ({
        toolpads: {
            ...state.toolpads,
            [id]: { ...state.toolpads[id], isOpen: !state.toolpads[id].isOpen },
        },
    })),
    openToolpad: (id) => set((state) => ({
        toolpads: {
            ...state.toolpads,
            [id]: { ...state.toolpads[id], isOpen: true },
        },
    })),
    closeToolpad: (id) => set((state) => ({
        toolpads: {
            ...state.toolpads,
            [id]: { ...state.toolpads[id], isOpen: false },
        },
    })),
    setToolpadPosition: (id, position) => set((state) => ({
        toolpads: {
            ...state.toolpads,
            [id]: { ...state.toolpads[id], position },
        },
    })),
    // Modal actions
    openModal: (type, data = null) => set({ modal: { isOpen: true, type, data } }),
    closeModal: () => set({ modal: { isOpen: false, type: null, data: null } }),
    // Sidebar actions
    toggleLeftSidebar: () => set((state) => ({ leftSidebarOpen: !state.leftSidebarOpen })),
    toggleRightSidebar: () => set((state) => ({ rightSidebarOpen: !state.rightSidebarOpen })),
    toggleBottomPanel: () => set((state) => ({ bottomPanelOpen: !state.bottomPanelOpen })),
    setLeftSidebar: (open) => set({ leftSidebarOpen: open }),
    setRightSidebar: (open) => set({ rightSidebarOpen: open }),
    setBottomPanel: (open) => set({ bottomPanelOpen: open }),
}));
